//for all devices sensors data for the Select Sensors page in data mood
export const sensorsData = {
    // Ace: {
    ACE0: {
        mic: {
            sensors: 'Mic',
            activeImgURL: 'Activemic',
            inactiveImgURL: 'mic',
            reduxName: 'isMic',
            PABytesIndex: 11,
            PAByte: 'M',
        },
        temperature: {
            sensors: 'Temperature',
            activeImgURL: 'Activetemp',
            inactiveImgURL: 'temp',
            reduxName: 'isTemperature',
            PABytesIndex: 12,
            PAByte: 'T',
        },
        touch0: {
            sensors: 'Touch Zero',
            activeImgURL: 'ActivetouchZero',
            inactiveImgURL: 'touchZero',
            reduxName: 'isTouchZero',
            PABytesIndex: 2,
            PAByte: 'T',
        },
        touch1: {
            sensors: 'Touch One',
            activeImgURL: 'ActivetouchOne',
            inactiveImgURL: 'touchOne',
            reduxName: 'isTouchOne',
            PABytesIndex: 4,
            PAByte: 'T',
        },
        touch2: {
            sensors: 'Touch Two',
            activeImgURL: 'ActivetouchTwo',
            inactiveImgURL: 'touchTwo',
            reduxName: 'isTouchTwo',
            PABytesIndex: 6,
            PAByte: 'T',
        },
        distancesensor: {
            sensors: 'Distance Sensor',
            activeImgURL: 'Activedistance',
            inactiveImgURL: 'distance',
            reduxName: 'isDistanceSensors',
            PABytesIndex: 10,
            PAByte: 'D',
        },
        gesturesensor: {
            sensors: 'Gesture Sensor',
            activeImgURL: 'Activegesture',
            inactiveImgURL: 'gesture',
            reduxName: 'isGestureSensor',
            PABytesIndex: 10,
            PAByte: 'G',
        },
        colorsensor: {
            sensors: 'Color Sensor',
            activeImgURL: 'Activecolor',
            inactiveImgURL: 'color',
            reduxName: 'isColorSensor',
            PABytesIndex: 10,
            PAByte: 'C',
        },
        lightsensor: {
            sensors: 'Light Sensor',
            activeImgURL: 'Activelight',
            inactiveImgURL: 'light',
            reduxName: 'isLightSensor',
            PABytesIndex: 10,
            PAByte: 'L',
        },
    },
    ACE1: {
        mic: {
            sensors: 'Mic',
            activeImgURL: 'Activemic',
            inactiveImgURL: 'mic',
            reduxName: 'isMic',
            PABytesIndex: 14,
            PAByte: 'M',
        },
        temperature: {
            sensors: 'Temperature',
            activeImgURL: 'Activetemp',
            inactiveImgURL: 'temp',
            reduxName: 'isTemperature',
            PABytesIndex: 15,
            PAByte: 'T',
        },
        touch0: {
            sensors: 'Touch Zero',
            activeImgURL: 'ActivetouchZero',
            inactiveImgURL: 'touchZero',
            reduxName: 'isTouchZero',
            PABytesIndex: 16,
            PAByte: 'T',
        },
        touch1: {
            sensors: 'Touch One',
            activeImgURL: 'ActivetouchOne',
            inactiveImgURL: 'touchOne',
            reduxName: 'isTouchOne',
            PABytesIndex: 17,
            PAByte: 'T',
        },
        touch2: {
            sensors: 'Touch Two',
            activeImgURL: 'ActivetouchTwo',
            inactiveImgURL: 'touchTwo',
            reduxName: 'isTouchTwo',
            PABytesIndex: 18,
            PAByte: 'T',
        },
        touch3: {
            sensors: 'Touch Three',
            activeImgURL: 'ActivetouchThree',
            inactiveImgURL: 'touchThree',
            reduxName: 'isTouchThree',
            PABytesIndex: 19,
            PAByte: 'T',
        },
        distancesensor: {
            sensors: 'Distance Sensor',
            activeImgURL: 'Activedistance',
            inactiveImgURL: 'distance',
            reduxName: 'isDistanceSensors',
            PABytesIndex: 20,
            PAByte: 'D',
        },
        gesturesensor: {
            sensors: 'Gesture Sensor',
            activeImgURL: 'Activegesture',
            inactiveImgURL: 'gesture',
            reduxName: 'isGestureSensor',
            PABytesIndex: 20,
            PAByte: 'G',
        },
        colorsensor: {
            sensors: 'Color Sensor',
            activeImgURL: 'Activecolor',
            inactiveImgURL: 'color',
            reduxName: 'isColorSensor',
            PABytesIndex: 20,
            PAByte: 'C',
        },
        lightsensor: {
            sensors: 'Light Sensor',
            activeImgURL: 'Activelight',
            inactiveImgURL: 'light',
            reduxName: 'isLightSensor',
            PABytesIndex: 20,
            PAByte: 'L',
        },
        battery: {
            sensors: 'Battery',
            activeImgURL: 'Activebatt',
            inactiveImgURL: 'batt',
            reduxName: 'isBattery',
            PABytesIndex: 22,
            PAByte: 'B',
        },
        accelerometerX: {
            sensors: 'AccelerometerX',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isAccelerometerX',
            PABytesIndex: 21,
            PAByte: 'A',
        },
        accelerometerY: {
            sensors: 'AccelerometerY',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isAccelerometerY',
            PABytesIndex: 21,
            PAByte: 'A',
        },
        accelerometerZ: {
            sensors: 'AccelerometerZ',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isAccelerometerZ',
            PABytesIndex: 21,
            PAByte: 'A',
        },
        GyroX: {
            sensors: 'Gyro X',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isGyroX',
            PABytesIndex: 21,
            PAByte: 'A',
        },
        GyroY: {
            sensors: 'Gyro Y',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isGyroY',
            PABytesIndex: 21,
            PAByte: 'A',
        },
        GyroZ: {
            sensors: 'Gyro Z',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isGyroZ',
            PABytesIndex: 21,
            PAByte: 'A',
        },
    },
    // },
    // Humanoid: {
    HUMANOID0: {
        battery: {
            sensors: 'Battery',
            activeImgURL: 'Activebatt',
            inactiveImgURL: 'batt',
            reduxName: 'isBattery',
            PABytesIndex: 10,
            PAByte: 'B',
        },
        accelerometerX: {
            sensors: 'AccelerometerX',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isAccelerometerX',
            PABytesIndex: 11,
            PAByte: 'A',
        },
        accelerometerY: {
            sensors: 'AccelerometerY',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isAccelerometerY',
            PABytesIndex: 11,
            PAByte: 'A',
        },
        accelerometerZ: {
            sensors: 'AccelerometerZ',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isAccelerometerZ',
            PABytesIndex: 11,
            PAByte: 'A',
        },
        GyroX: {
            sensors: 'Gyro X',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isGyroX',
            PABytesIndex: 11,
            PAByte: 'A',
        },
        GyroY: {
            sensors: 'Gyro Y',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isGyroY',
            PABytesIndex: 11,
            PAByte: 'A',
        },
        GyroZ: {
            sensors: 'Gyro Z',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isGyroZ',
            PABytesIndex: 11,
            PAByte: 'A',
        },
    },
    HUMANOID1: {
        ultrasonic: {
            sensors: 'Ultrasonic',
            activeImgURL: 'ActiveHeadUltrasonice',
            inactiveImgURL: 'headUltrasonic',
            reduxName: 'isUltrasonic',
            PABytesIndex: 8,
            PAByte: 'U',
        },
        battery: {
            sensors: 'Battery',
            activeImgURL: 'Activebatt',
            inactiveImgURL: 'batt',
            reduxName: 'isBattery',
            PABytesIndex: 10,
            PAByte: 'B',
        },
        accelerometerX: {
            sensors: 'AccelerometerX',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isAccelerometerX',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        accelerometerY: {
            sensors: 'AccelerometerY',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isAccelerometerY',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        accelerometerZ: {
            sensors: 'AccelerometerZ',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isAccelerometerZ',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroX: {
            sensors: 'Gyro X',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isGyroX',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroY: {
            sensors: 'Gyro Y',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isGyroY',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroZ: {
            sensors: 'Gyro Z',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isGyroZ',
            PABytesIndex: 9,
            PAByte: 'A',
        },
    },
    HUMANOID2: {
        ultrasonic: {
            sensors: 'Ultrasonic',
            activeImgURL: 'ActiveHeadUltrasonice',
            inactiveImgURL: 'headUltrasonic',
            reduxName: 'isUltrasonic',
            PABytesIndex: 8,
            PAByte: 'U',
        },
        battery: {
            sensors: 'Battery',
            activeImgURL: 'Activebatt',
            inactiveImgURL: 'batt',
            reduxName: 'isBattery',
            PABytesIndex: 10,
            PAByte: 'B',
        },
        accelerometerX: {
            sensors: 'AccelerometerX',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isAccelerometerX',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        accelerometerY: {
            sensors: 'AccelerometerY',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isAccelerometerY',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        accelerometerZ: {
            sensors: 'AccelerometerZ',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isAccelerometerZ',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroX: {
            sensors: 'Gyro X',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isGyroX',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroY: {
            sensors: 'Gyro Y',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isGyroY',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroZ: {
            sensors: 'Gyro Z',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isGyroZ',
            PABytesIndex: 9,
            PAByte: 'A',
        },
    },
    HUMANOID3: {
        ultrasonic: {
            sensors: 'Ultrasonic',
            activeImgURL: 'ActiveHeadUltrasonice',
            inactiveImgURL: 'headUltrasonic',
            reduxName: 'isUltrasonic',
        },
        battery: {
            sensors: 'Battery',
            activeImgURL: 'Activebatt',
            inactiveImgURL: 'batt',
            reduxName: 'isBattery',
        },
        accelerometerX: {
            sensors: 'AccelerometerX',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isAccelerometerX',
        },
        accelerometerY: {
            sensors: 'AccelerometerY',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isAccelerometerY',
        },
        accelerometerZ: {
            sensors: 'AccelerometerZ',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isAccelerometerZ',
        },
        GyroX: {
            sensors: 'Gyro X',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isGyroX',
        },
        GyroY: {
            sensors: 'Gyro Y',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isGyroY',
        },
        GyroZ: {
            sensors: 'Gyro Z',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isGyroZ',
        },
    },
    // },
    // Hexapod: {
    HEXAPOD1: {
        ultrasonic: {
            sensors: 'Ultrasonic',
            activeImgURL: 'ActiveHeadUltrasonice',
            inactiveImgURL: 'headUltrasonic',
            reduxName: 'isUltrasonic',
            PABytesIndex: 8,
            PAByte: 'U',
        },
        battery: {
            sensors: 'Battery',
            activeImgURL: 'Activebatt',
            inactiveImgURL: 'batt',
            reduxName: 'isBattery',
            PABytesIndex: 10,
            PAByte: 'B',
        },
        accelerometerX: {
            sensors: 'AccelerometerX',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isAccelerometerX',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        accelerometerY: {
            sensors: 'AccelerometerY',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isAccelerometerY',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        accelerometerZ: {
            sensors: 'AccelerometerZ',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isAccelerometerZ',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroX: {
            sensors: 'Gyro X',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isGyroX',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroY: {
            sensors: 'Gyro Y',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isGyroY',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroZ: {
            sensors: 'Gyro Z',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isGyroZ',
            PABytesIndex: 9,
            PAByte: 'A',
        },
    },
    HEXAPOD2: {
        ultrasonic: {
            sensors: 'Ultrasonic',
            activeImgURL: 'ActiveHeadUltrasonice',
            inactiveImgURL: 'headUltrasonic',
            reduxName: 'isUltrasonic',
            PABytesIndex: 8,
            PAByte: 'U',
        },
        battery: {
            sensors: 'Battery',
            activeImgURL: 'Activebatt',
            inactiveImgURL: 'batt',
            reduxName: 'isBattery',
            PABytesIndex: 10,
            PAByte: 'B',
        },
        accelerometerX: {
            sensors: 'AccelerometerX',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isAccelerometerX',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        accelerometerY: {
            sensors: 'AccelerometerY',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isAccelerometerY',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        accelerometerZ: {
            sensors: 'AccelerometerZ',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isAccelerometerZ',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroX: {
            sensors: 'Gyro X',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isGyroX',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroY: {
            sensors: 'Gyro Y',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isGyroY',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroZ: {
            sensors: 'Gyro Z',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isGyroZ',
            PABytesIndex: 9,
            PAByte: 'A',
        },
    },
    HEXAPOD3: {
        ultrasonic: {
            sensors: 'Ultrasonic',
            activeImgURL: 'ActiveHeadUltrasonice',
            inactiveImgURL: 'headUltrasonic',
            reduxName: 'isUltrasonic',
            PABytesIndex: 8,
            PAByte: 'U',
        },
        battery: {
            sensors: 'Battery',
            activeImgURL: 'Activebatt',
            inactiveImgURL: 'batt',
            reduxName: 'isBattery',
            PABytesIndex: 10,
            PAByte: 'B',
        },
        accelerometerX: {
            sensors: 'AccelerometerX',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isAccelerometerX',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        accelerometerY: {
            sensors: 'AccelerometerY',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isAccelerometerY',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        accelerometerZ: {
            sensors: 'AccelerometerZ',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isAccelerometerZ',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroX: {
            sensors: 'Gyro X',
            activeImgURL: 'ActiveacceX',
            inactiveImgURL: 'acceX',
            reduxName: 'isGyroX',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroY: {
            sensors: 'Gyro Y',
            activeImgURL: 'ActiveacceY',
            inactiveImgURL: 'acceY',
            reduxName: 'isGyroY',
            PABytesIndex: 9,
            PAByte: 'A',
        },
        GyroZ: {
            sensors: 'Gyro Z',
            activeImgURL: 'ActiveacceZ',
            inactiveImgURL: 'acceZ',
            reduxName: 'isGyroZ',
            PABytesIndex: 9,
            PAByte: 'A',
        },
    },
    // },
    // Roboki: {
    ROBOKI1: {
        switch1: {
            sensors: 'Switch One',
            activeImgURL: 'ActiveSwitch1',
            inactiveImgURL: 'switch1',
            reduxName: 'isSwitchOne',
            PABytesIndex: 6,
            PAByte: 'I',
        },
        switch2: {
            sensors: 'Switch Two',
            activeImgURL: 'ActiveSwitch2',
            inactiveImgURL: 'switch2',
            reduxName: 'isSwitchTwo',
            PABytesIndex: 7,
            PAByte: 'I',
        },
    },
    // },
}

//here {dataKey:value} value is the name of the state of sensors data store in the LinGraphChart components
//in line Graph and Bar Graph the sidebar data
export const graphSidebarData = {
    mic: {
        sensors: 'Microphone',
        bgColour: '#9F0344',
        reduxName: 'isMic',
        dataKey: 'mic',
    },
    temperature: {
        sensors: 'Temperature',
        bgColour: '#B47623',
        reduxName: 'isTemperature',
        dataKey: 'temp',
    },
    battery: {
        sensors: 'Battery',
        bgColour: '#D9B102',
        reduxName: 'isBattery',
        dataKey: 'batt',
    },
    ultrasonic: {
        sensors: 'Ultrasonic',
        bgColour: '#58D68D',
        reduxName: 'isUltrasonic',
        dataKey: 'ultrasonic',
    },
    touch0: {
        sensors: 'Touch 0',
        bgColour: '#006D70',
        reduxName: 'isTouchZero',
        dataKey: 'touch0',
    },
    touch1: {
        sensors: 'Touch 1',
        bgColour: '#260659',
        reduxName: 'isTouchOne',
        dataKey: 'touch1',
    },
    touch2: {
        sensors: 'Touch 2',
        bgColour: '#BC7C68',
        reduxName: 'isTouchTwo',
        dataKey: 'touch2',
    },
    touch3: {
        sensors: 'Touch 3',
        bgColour: '#ED5B22',
        reduxName: 'isTouchThree',
        dataKey: 'touch3',
    },
    accelerometerX: {
        sensors: 'AccelerometerX',
        bgColour: '#EC9EA4',
        reduxName: 'isAccelerometerX',
        dataKey: 'acceX',
    },
    accelerometerY: {
        sensors: 'AccelerometerY',
        bgColour: '#EDDD8A',
        reduxName: 'isAccelerometerY',
        dataKey: 'acceY',
    },
    accelerometerZ: {
        sensors: 'AccelerometerZ',
        bgColour: '#97CEEA',
        reduxName: 'isAccelerometerZ',
        dataKey: 'acceZ',
    },
    GyroX: {
        sensors: 'Gyro X',
        bgColour: '#B39485',
        reduxName: 'isGyroX',
        dataKey: 'gyroX',
    },
    GyroY: {
        sensors: 'Gyro Y',
        bgColour: '#FA8D5A',
        reduxName: 'isGyroY',
        dataKey: 'gyroY',
    },
    GyroZ: {
        sensors: 'Gyro Z',
        bgColour: '#541743',
        reduxName: 'isGyroZ',
        dataKey: 'gyroZ',
    },
    distancesensor: {
        sensors: 'Proximity Sensor',
        bgColour: '#B24E4E',
        reduxName: 'isDistanceSensors',
        dataKey: 'proximity',
    },
    lightsensor: {
        sensors: 'Light Sensor',
        bgColour: '#7E3733',
        reduxName: 'isLightSensor',
        dataKey: 'light',
    },
    colorsensorRed: {
        sensors: 'Color Sensor (Red)',
        bgColour: 'red',
        // reduxName: 'isColorSensor',
        reduxName: 'isRedLight',
        dataKey: 'red',
    },
    colorsensorBlue: {
        sensors: 'Color Sensor (Blue)',
        bgColour: 'blue',
        // reduxName: 'isColorSensor',
        reduxName: 'isBlueLight',
        dataKey: 'blue',
    },
    colorsensorGreen: {
        sensors: 'Color Sensor (Green)',
        bgColour: 'green',
        // reduxName: 'isColorSensor',
        reduxName: 'isGreenLight',
        dataKey: 'green',
    },
    gesturesensor: {
        sensors: 'Gesture Sensor',
        bgColour: '#382903',
        reduxName: 'isGestureSensor',
        dataKey: 'gesture',
    },
    switch1: {
        sensors: 'Switch One',
        bgColour: '#8BC9A6 ',
        reduxName: 'isSwitchOne',
        dataKey: 'switch1',
    },
    switch2: {
        sensors: 'Switch Two',
        bgColour: '#6774D2 ',
        reduxName: 'isSwitchTwo',
        dataKey: 'switch2',
    },
}

const HUMANOID1 = {
    batt: { index: 21, reduxName: 'isBattery' },
    acceX: { index: 23, reduxName: 'isAccelerometerX' },
    acceY: { index: 24, reduxName: 'isAccelerometerY' },
    acceZ: { index: 25, reduxName: 'isAccelerometerZ' },
    gyroX: { index: 26, reduxName: 'isGyroX' },
    gyroY: { index: 27, reduxName: 'isGyroY' },
    gyroZ: { index: 28, reduxName: 'isGyroZ' },
    ultrasonic: { index: 22, reduxName: 'isUltrasonic' },
    A1: { index: 31, reduxName: '' },
    A2: { index: 32, reduxName: '' },
    B1: { index: 33, reduxName: '' },
    B2: { index: 34, reduxName: '' },
    C1: { index: 35, reduxName: '' },
    C2: { index: 36, reduxName: '' },
    D1: { index: 37, reduxName: '' },
    D2: { index: 38, reduxName: '' },
}
//avlabel sensor in pa read for each device and there index (this index shows wher the red value are present)
export const deviceReadIndex = {
    ACE1: {
        A1: { index: 2, reduxName: '' },
        A2: { index: 3, reduxName: '' },
        B1: { index: 4, reduxName: '' },
        B2: { index: 5, reduxName: '' },
        C1: { index: 6, reduxName: '' },
        C2: { index: 7, reduxName: '' },
        D1: { index: 8, reduxName: '' },
        D2: { index: 9, reduxName: '' },
        E1: { index: 10, reduxName: '' },
        E2: { index: 11, reduxName: '' },
        F1: { index: 12, reduxName: '' },
        F2: { index: 13, reduxName: '' },
        mic: { index: 14, reduxName: 'isMic' },
        temp: { index: 15, reduxName: 'isTemperature' },
        touch0: { index: 16, reduxName: 'isTouchZero' },
        touch1: { index: 17, reduxName: 'isTouchOne' },
        touch2: { index: 18, reduxName: 'isTouchTwo' },
        touch3: { index: 19, reduxName: 'isTouchThree' },
        red: { index: '20C', reduxName: 'isRedLight' },
        green: { index: '20C', reduxName: 'isGreenLight' },
        blue: { index: '20C', reduxName: 'isBlueLight' },
        gesture: { index: '20G', reduxName: 'isGestureSensor' },
        proximity: { index: '20D', reduxName: 'isDistanceSensors' },
        light: { index: '20L', reduxName: 'isLightSensor' },
        acceX: { index: '21X', reduxName: 'isAccelerometerX' },
        acceY: { index: '21Y', reduxName: 'isAccelerometerY' },
        acceZ: { index: '21Z', reduxName: 'isAccelerometerZ' },
        gyroX: { index: '21GX', reduxName: 'isGyroX' },
        gyroY: { index: '21GY', reduxName: 'isGyroY' },
        gyroZ: { index: '21GZ', reduxName: 'isGyroZ' },
        batt: { index: 22, reduxName: 'isBattery' },
    },
    HUMANOID0: HUMANOID1,
    HUMANOID1: HUMANOID1,
    HUMANOID2: HUMANOID1,
    HEXAPOD1: HUMANOID1,
    HEXAPOD2: HUMANOID1,
    HEXAPOD3: HUMANOID1,
    ROBOKI1: {
        switch1: { index: 23, reduxName: 'isSwitchOne' },
        switch2: { index: 24, reduxName: 'isSwitchTwo' },
        A1: { index: 2, reduxName: '' },
        A2: { index: 3, reduxName: '' },
        B1: { index: 6, reduxName: '' },
        B2: { index: 7, reduxName: '' },
    },
}
